import { Component, Input } from "@angular/core";

import { PageObjectArrow } from "src/app/models/pageobjectarrow";

@Component({
  selector: "hkt-pageobjectarrow",
  templateUrl: "./pageobjectarrow.component.html",
  styleUrls: ["./pageobjectarrow.component.scss"],
})
export class PageObjectArrowComponent {
  @Input("obj") obj: PageObjectArrow;
  @Input("mode") mode: string;

  constructor() {}
}
